module.exports = __webpack_public_path__ + "media/images/city_img/a_1-ed7a084621a02451318516dcbc499dea.jpg";